import { httpsCallable } from 'firebase/functions';
import { functions } from './firebase';

export type ExtractDeckTextResponse = {
  text: string;
};

export function extractDeckTextErrorMessage(err: unknown): string {
  if (err && typeof err === 'object' && 'code' in err) {
    const code = String((err as { code: string }).code);
    if (code === 'functions/failed-precondition') {
      return 'PDF exceeds the 15 MB size limit.';
    }
    if (code === 'functions/not-found') {
      return 'Deck PDF not found in storage.';
    }
    if (code === 'functions/permission-denied') {
      return 'You do not have permission to read this deck.';
    }
    if (code === 'functions/unauthenticated') {
      return 'Sign in to extract deck text.';
    }
  }
  return err instanceof Error ? err.message : 'Text extraction failed.';
}

export async function extractDeckText(storagePath: string): Promise<string> {
  const fn = httpsCallable<{ storagePath: string }, ExtractDeckTextResponse>(
    functions,
    'extractDeckText'
  );
  const result = await fn({ storagePath: storagePath.trim() });
  return typeof result.data.text === 'string' ? result.data.text : '';
}
